var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgReportIcon = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 8,
    height: 12,
    viewBox: "0 0 8 12",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "flag",
    transform: "translate(-6.75 -2.25)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_57",
    "data-name": "Path 57",
    d: "M7.24,2.25a.462.462,0,0,1,.49.429V13.821a.494.494,0,0,1-.979,0V2.679A.462.462,0,0,1,7.24,2.25Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_58",
    "data-name": "Path 58",
    d: "M8.1,4.411a3.139,3.139,0,0,1,2.164-1.036,1.88,1.88,0,0,1,1.182.55l.025.021c.309.255.511.407.769.407a1.158,1.158,0,0,0,.464-.123q.238-.112.469-.245c.046-.027.092-.052.142-.078A3.453,3.453,0,0,1,15,3.375a.45.45,0,0,1,.4.49V9.739a.45.45,0,0,1-.4.49,2.811,2.811,0,0,0-1.37.447l-.126.069c-.174.1-.358.2-.536.281a1.8,1.8,0,0,1-.734.182,1.88,1.88,0,0,1-1.182-.55l-.025-.021c-.309-.255-.511-.407-.769-.407-.658,0-.963.241-1.757.9a.356.356,0,0,1-.543-.168.56.56,0,0,1,.135-.672,3.138,3.138,0,0,1,2.164-1.036,1.88,1.88,0,0,1,1.182.55l.025.021c.309.255.511.407.769.407a1.158,1.158,0,0,0,.464-.123c.148-.067.3-.15.469-.245.046-.027.092-.052.142-.078a3.945,3.945,0,0,1,1.3-.5V4.4a3.579,3.579,0,0,0-.975.405l-.126.069c-.174.1-.358.2-.536.281a1.8,1.8,0,0,1-.734.182,1.88,1.88,0,0,1-1.182-.55l-.025-.021c-.309-.255-.511-.407-.769-.407-.658,0-.963.241-1.757.9a.352.352,0,0,1-.54-.143.567.567,0,0,1,.1-.672L8.1,4.411Z",
    transform: "translate(-0.648 -0.635)"
  }))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgReportIcon);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/report_icon.7efaeaa2c51121565c687ff20811e2b6.svg";